module.exports = __webpack_public_path__ + "static/img/consumer-h5-5.9ad8d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-5.png
// module id = oHhb
// module chunks = 34